import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { all, put, delay, takeLatest, takeEvery } from "redux-saga/effects";
import { usersListRequestService, usersSaveRequestService, usersRemoveRequestService } from "./services";
import history from '../../providers/history';
import { usersListFailure, usersListRequest, usersListSuccess, usersSetPagination, usersSaveRequest, usersSaveSuccess, stopEditingUsers, usersSaveFailure, usersRemoveSuccess, usersRemoveFailure, usersRemoveRequest } from "./slice";
import { IUserFilter, IUsersResponse, IUser, IUserSaveRequestPayload, IUserSaveRequestResponse, IUserRemoveRequestResponse } from "./types";


//LIST USERS
function* usersListRequestSaga(action: PayloadAction<IUserFilter | undefined>) {
    try {
        const usersListResponse: AxiosResponse<IUsersResponse> = yield usersListRequestService(action.payload);

        if (usersListResponse.data.status) {
            yield put(usersListSuccess(usersListResponse.data.data))
            yield put(usersSetPagination({
                count: usersListResponse.data.count,
                countFiltered: usersListResponse.data.countFiltered
            }))
        }
        else {
            yield put(usersListFailure({
                message: usersListResponse.data.message || 'Error trying to get users list'
            }));
        }
    }
    catch (error: any) {
        yield put(usersListFailure({
            message: error.response.data.message || 'Error trying to get users list'
        }));
    }
}

function* watchUsersListRequestSaga() {
    yield takeLatest(usersListRequest.type, usersListRequestSaga);
}

//SAVE USERS
function* userSaveRequestSaga(action: PayloadAction<IUser>) {

    try {
        const payloadUser: IUserSaveRequestPayload = {
            name: action.payload.name,
            email: action.payload.email,
            password: action.payload.password,
        }

        const usersSaveResponse: AxiosResponse<IUserSaveRequestResponse> = yield usersSaveRequestService(payloadUser, action.payload.id);

        if (usersSaveResponse.data.status) {
            yield put(usersSaveSuccess({
                ...action.payload,

                name: usersSaveResponse.data.data.name,
                email: usersSaveResponse.data.data.email,
                password: usersSaveResponse.data.data.password,
                id: usersSaveResponse.data.data.id,
            }))

            yield put(stopEditingUsers())
            history.back();
            yield delay(50);

        }
        else {
            yield put(usersSaveFailure({
                id: action.payload.id || "",
                error: {
                    message: usersSaveResponse.data.message || 'Error trying to save user'
                }
            }));
        }
    }
    catch (error: any) {

        yield put(usersSaveFailure({
            id: action.payload.id || "",
            error: {
                message: error.response.data.message || 'Error trying to get the list of user'
            }
        }));
    }
}

function* watchUserRequestSaga() {
    yield takeLatest(usersSaveRequest.type, userSaveRequestSaga);
}

//REMOVE USERS

function* usersRemoveSaga(action: PayloadAction<string>) {
    try {
        const userRemoveResponse: AxiosResponse<IUserRemoveRequestResponse> = yield usersRemoveRequestService(action.payload);

        if (userRemoveResponse.data.status) {
            history.back();

            yield put(usersRemoveSuccess(action.payload))
        }
        else {
            yield put(usersRemoveFailure({
                userId: action.payload,
                error: {
                    message: userRemoveResponse.data.message || 'Error trying to remove this user'
                }
            }));
        }
    } catch (error: any) {
        yield put(usersRemoveFailure({
            userId: action.payload,
            error: {
                message: error.response.data.message || 'Error trying to remove this user'
            }
        }));
    }
}

function* watchUsersRemoveSaga() {
    yield takeEvery(usersRemoveRequest.type, usersRemoveSaga);
}

export default all([
    watchUsersListRequestSaga(),
    watchUserRequestSaga(),
    watchUsersRemoveSaga(),
])